import { useRef } from "react";
import { Button, Dropdown, Icon } from "semantic-ui-react";

import { Can, NavBarSearch, NavPortal } from "components";
import { ROLES, USER_STATUSES, User } from "models";
import { CreateUserForm, EditUserForm, UsersTable } from "modules/Users/components";
import { USERS_MODALS, useGetFilterOptions, useUsers, useUsersFilters } from "modules/Users/hooks";
import { useUsersFilterHandlers } from "modules/Users/hooks";
import "modules/Users/Users.scss";

const Users = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const {
    filters: { search_term }
  } = useUsersFilters();
  const { handleSearchTermChange, handleRoleChange, handleStatusChange } = useUsersFilterHandlers();
  const { roleOptionsWithAll, statusOptionsWithAll } = useGetFilterOptions();
  const { createUserModal, selectedUser, editUserModal, deleteUserModal, handleSelectUser, handleCloseModal, handleOpenModal } = useUsers();

  return (
    <div ref={containerRef} className="Users">
      <NavPortal>
        <NavBarSearch handleSearchChange={handleSearchTermChange} value={search_term} />
      </NavPortal>

      <div className="Users__toolbar">
        <Can I="create" the="users">
          <Button icon labelPosition="left" onClick={() => handleOpenModal(USERS_MODALS.CreateUserModal)}>
            <Icon className="plus" />
            <span className="Users__create-text">Add User</span>
          </Button>
        </Can>
        <div className="Users__dropdown-container">
          <Dropdown
            fluid
            selection
            options={roleOptionsWithAll}
            selectOnBlur={false}
            placeholder="Select Role"
            onChange={(_, { value }) => handleRoleChange(!value ? null : (value as ROLES))}
          />
        </div>
        <div className="Users__dropdown-container">
          <Dropdown
            fluid
            selection
            options={statusOptionsWithAll}
            selectOnBlur={false}
            placeholder="Select Status"
            onChange={(_, { value }) => handleStatusChange(!value ? null : (value as USER_STATUSES))}
          />
        </div>
      </div>

      <CreateUserForm isOpen={createUserModal} onClose={() => handleCloseModal(USERS_MODALS.CreateUserModal)} />
      {selectedUser && (
        <EditUserForm
          isOpen={editUserModal}
          deleteUserModal={deleteUserModal}
          handleCloseModal={handleCloseModal}
          handleOpenModal={handleOpenModal}
          onClose={() => handleCloseModal(USERS_MODALS.EditUserModal)}
          user={selectedUser}
        />
      )}
      <UsersTable handleOnRowClick={(data: User) => handleSelectUser(data)} />
    </div>
  );
};

export default Users;
